import React from 'react';
import {Table, Row, Col} from 'react-bootstrap';

export function SummaryTable(props) {
  const {header, moreButton, caption, columns, rows, summaries} = props;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-5">
        <p className="fon-weight-boldest text-primary mb-0 font-size-h5">{header}</p>
        {moreButton && (moreButton)}
      </div>

      {summaries && (
        <Row className="mb-5">
          {summaries.map(summary => {
            return (
            <Col xs={4} sm={3} key={`summ-${summary.key}`}>
            <p className="mb-1 text-dark">{summary.label}</p>
            <p className="mb-0 font-weight-bolder font-size-lg">{summary.value}</p>
            </Col>
            )
          })}
        </Row>
      )}

      <p className="mb-2 text-muted font-size-sm font-weight-bold">{caption}</p>
      <Table bordered responsive>
        <thead>
        <tr className="bg-light">
          {columns.map((col, index) => (
            <th key={`thead-${index}-${col.key}`} className="text-center font-size-xs py-3">
              {col.label}
            </th>
          ))}
        </tr>
        </thead>

        <tbody>
        {rows.map((row, index) => (
          <tr key={`trow-${index}}`}>
            {row.map((col, _index) => {
              const key = columns[_index].key;
              return <td key={`td-${index}-${_index}`}>{row[key]}</td>
            })}
          </tr>
        ))}
        {!rows.length && (
          <tr>
            <td colSpan={columns.length} className="text-center">
              등록된 데이터가 없습니다.
            </td>
          </tr>
        )}
        </tbody>
      </Table>

    </div>
  );
}
